import React from 'react';
import Image from '@atlaskit/image';
import configModalIllustration from './assets/config-modal-illustration.svg';

export const ConfigModalIllustration = ({ alt }: { alt: string }) => (
	<Image src={configModalIllustration} alt={alt} />
);
